<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title :class="{ 'hidden-sm-and-down': showSearch }">
        Sign-ups
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-row v-if="showSearch" align="center" style="max-width: 300px;">
        <v-text-field
          flat
          hide-details
          single-line
          label="Search name, email or phone number"
          v-model="filter.search"
          @input="search"
        >
        </v-text-field>
      </v-row>
      <v-btn class="ml-5" icon @click="showSearch = !showSearch">
        <v-icon>{{ icons.search }}</v-icon>
      </v-btn>
    </v-app-bar>
    <div class="ma-4" id="user-list">
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left">Name</th>
            <th class="text-left">Email</th>
            <th class="text-left">Phone number</th>
            <th class="text-left">School</th>
            <th class="text-left">Date signed up</th>
            <th><span></span></th>
          </tr>
        </thead>
        <tbody>
          <template v-if="inquiries.data.length">
            <tr v-for="user in inquiries.data" :key="user.id">
              <td>
                <text-highlight :queries="filter.search">
                  {{ user.full_name }}
                </text-highlight>
              </td>
              <td>
                <text-highlight :queries="filter.search">
                  {{ user.email }}
                </text-highlight>
              </td>
              <td>
                <text-highlight :queries="filter.search">
                  {{ user.phone_number ? '+' + user.phone_number : '' }}
                </text-highlight>
              </td>
              <td>{{ user.school }}</td>
              <td>{{ user.signedUpDate }}</td>
              <td class="text-right">
                <router-link
                  :to="{ name: 'inquiries.details', params: { id: user.id } }"
                >
                  <v-btn text icon>
                    <v-icon dark>{{ icons.view }}</v-icon>
                  </v-btn>
                </router-link>
              </td>
            </tr>
          </template>
          <tr v-else>
            <td class="text-center headline grey--text py-10" colspan="6">
              No inquiries
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-overlay absolute :value="loading" opacity="0.1">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </div>
    <div v-if="paginationLength > 1" class="text-center mt-4">
      <v-pagination
        @input="pageChanged"
        :value="inquiries.meta.current_page"
        :length="paginationLength"
        :total-visible="inquiries.meta.per_page"
        circle
      >
      </v-pagination>
    </div>
  </div>
</template>

<script>
import {
  mdiDotsVertical,
  mdiUnfoldMoreHorizontal,
  mdiMagnify,
  mdiAccountCircleOutline,
  mdiChevronRight
} from '@mdi/js'
import debounce from 'lodash/debounce'
import TextHighlight from 'vue-text-highlight'
import UserInquiry from '@/models/UserInquiry'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

export default {
  name: 'UsersPage',

  components: {
    TextHighlight,
    AppBarNavIcon
  },

  data() {
    return {
      loading: false,
      showSearch: false,
      filter: {
        search: ''
      },
      icons: {
        settings: mdiDotsVertical,
        sort: mdiUnfoldMoreHorizontal,
        search: mdiMagnify,
        view: mdiAccountCircleOutline,
        arrow: mdiChevronRight
      },
      inquiries: {
        data: [],
        meta: {
          current_page: 1
        }
      }
    }
  },

  computed: {
    paginationLength() {
      return this.inquiries.meta.last_page
    }
  },

  methods: {
    getUsers() {
      this.loading = true
      return UserInquiry.where('search', this.filter.search)
        .page(parseInt(this.inquiries.meta.current_page))
        .limit(10)
        .get()
        .then(response => {
          this.inquiries = response
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },

    pageChanged(page) {
      this.inquiries.meta.current_page = page
      this.getUsers()
    },

    search: debounce(function() {
      this.getUsers()
    }, 600)
  },

  created() {
    this.getUsers()
  }
}
</script>
